/* eslint-disable react/react-in-jsx-scope */
import { Box, Container, Text } from '@chakra-ui/react';
import AgendaWrapper from '@/components/agenda/AgendaWrapper';
import EventCard, { IAgendaEvent } from '@/components/agenda/EventCard';

const agendaDay2: Array<IAgendaEvent[]> = [
  [
    {
      id: 'Day2_1',
      timing: {
        start: '09:00 AM',
        end: '10:00 AM',
      },
      normalHeading: 'Registration and Networking Breakfast',
    },
    {
      id: 'Day2_2',
      timing: {
        start: '10:00 AM',
        end: '10:10 AM',
      },
      normalHeading: 'Welcome Address',
    },
    {
      id: 'Day2_2',
      timing: {
        start: '10:10 AM',
        end: '10:20 AM',
      },
      normalHeading: 'Keynote Address',
      speakers: [
        {
          name: 'Prashanth Prakash',
          designation: 'Founding Partner, Accel Partners India',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/PrashanthPrakash-aytBN6agwoFw.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/prashanth-prakash',
        },
      ],
    },
    {
      id: 'Day2_3',
      timing: {
        start: '10:20 AM',
        end: '10:30 AM',
      },

      normalHeading: 'Start-up Showcase Session',

      ytLink: 'https://youtu.be/Df_Ced-8b7A?feature=shared',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
    },
    {
      id: 'Day2_4',
      timing: {
        start: '10:30 AM',
        end: '11:10 AM',
      },
      accentTag: 'Panel Discussion',
      normalHeading:
        'Attracting Global and Domestic Capital: LP Views on India Alts Allocations',
      ytLink: 'https://youtu.be/_6g7ypiRMOY?feature=shared',
      speakers: [
        {
          name: 'Kazushige Kobayashi',
          designation: 'Managing Director, MCP Asset Management',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/KazushigeKobayashi-oilUrVnBRlI2.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/kazushige-kobayashi',
        },
        {
          name: 'Nipun Sahni',
          designation: 'Advisor, Apollo Global Management',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/nipun-sahni',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-27at35900PM-UpLLWyT4rQW4.jpeg',
        },

        {
          name: 'Samir Sawhney',
          designation: 'Chief General Manager, State Bank of India',
        },
        {
          name: 'Tushar Kumar',
          designation: 'Partner, Just Climate',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/tushar-kumar',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/tusharkumar-MqnRyVfCAAGr.jpg',
        },
        {
          name: 'Shantanu Naravane',
          designation: 'Partner, Herbert Smith Freehills (Moderator)',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shantanu-naravane',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/shantanunaravaneWEB58780-jfwWp76CVXGp.jpg',
        },
      ],
    },
    {
      id: 'Day2_3',
      timing: {
        start: '11:10 AM',
        end: '11:20 AM',
      },
      normalHeading: 'Start-up Showcase Session',

      ytLink: 'https://youtu.be/Df_Ced-8b7A?feature=shared',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
    },
    {
      id: 'Day2_5',
      timing: {
        start: '11:20 AM',
        end: '11:40 AM',
      },
      normalHeading: 'Fireside Chat',
      ytLink: 'https://youtu.be/tQ8YBCtmLaU?feature=shared',
      speakers: [
        {
          name: 'Shri NK Singh',
          designation:
            'Former Chairman of the 15th Finance Commission and Former Member of Parliament, Government of India',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at110225PM-ZnMfUQRRD9HC.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shri-n-k-singh',
        },
        {
          name: 'Shalabh Tandon',
          designation:
            'South Asia Regional Head of Operations & Climate Change, IFC',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/shalabhtandon-w9foJvNSskDj.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shalabh-tandon',
        },
      ],
    },
    {
      id: 'Day1_8',
      timing: {
        start: '11:40 AM',
        end: '12:00 PM',
      },
      normalHeading: 'Presentation',
    },
    {
      id: 'Day2_6',
      timing: {
        start: '12:00 PM',
        end: '12:20 PM',
      },
      accentTag: 'Fireside Chat',
      normalHeading:
        'From Commitment to Action in Climate Financing: A G20 Imperative',
      speakers: [
        {
          name: 'Shri Amitabh Kant',
          designation: 'G20 Sherpa of India',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-06at14854PM-c2uDarqciHkT.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shri-amitabh-kant',
        },
        {
          name: 'Pratibha Jain',
          designation:
            'Co-chair, IVCA Climate & Sustainability Council and Head of Strategy and Group General Counsel, Everstone Group',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/pratibhajain-XZbjbF86MPhV.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/pratibha-jain',
        },
      ],
      ytLink: 'https://youtu.be/Wf8mBIeVQr0?feature=shared',
    },
    {
      id: 'Day2_7',
      timing: {
        start: '12:20 PM',
        end: '12:30 PM',
      },
      normalHeading: 'Start-up Showcase Session',

      ytLink: 'https://youtu.be/Df_Ced-8b7A?feature=shared',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
    },
    {
      id: 'Day2_7',
      timing: {
        start: '12:30 PM',
        end: '01:30 PM',
      },
      accentTag: 'Break',
      normalHeading: 'Networking Lunch',
    },
    {
      id: 'Day2_8',
      timing: {
        start: '01:30 PM',
        end: '02:10 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading: 'Innovation and new technologies in Climate Space',
      ytLink: 'https://youtu.be/dBS-Y7csCiM?feature=shared',
      speakers: [
        {
          name: 'Rema Subramanian',
          designation: 'Co-Founder, Managing Partner, Ankur Capital',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/RemaPhoto-2020-1d79L5Xbd5LP.JPG',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/rema-subramanian',
        },
        {
          name: 'Ruchira Shukla',
          designation: 'Co-Founder and Managing Partner, Synapses',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/RSPhoto-w9fpJvyH4m6s.JPG',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/ruchira-shukla',
        },
        {
          name: 'Kunal Khattar',
          designation: 'Founder & Managing Partner at AdvantEdge Founders',
        },

        {
          name: 'Shailesh Vickram Singh',
          designation: 'Founder & Managing Partner, Climate Angels Fund',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shailesh-vickram-singh',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/SVSPic-jfwWp761UBMl.jpg',
        },
        {
          name: 'Swapna Gupta',
          designation: 'Partner, Avaana Climate and Sustainability Fund',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Swapnahighresolutionpic-jfwuwp7nLx8ar.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/swapna-gupta',
        },
        {
          name: 'Arpit Agarwal',
          designation: 'Partner, Blume Ventures (Moderator)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-21at55504PM-c2u8arVi3oo9.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/arpit-agarwal',
        },
      ],
    },
    {
      id: 'Day1_8',
      timing: {
        start: '02:10 PM',
        end: '02:15 PM',
      },
      normalHeading: 'Brief Talk on Mobility Sector',

      speakers: [
        {
          name: 'Mahua Acharya',
          designation: 'Founder CEO, INTENT',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Mahua-Acharya--GLUZccEGzm8z.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/mahua-acharya',
        },
      ],
    },
    {
      id: 'Day2_9',
      timing: {
        start: '02:15 PM',
        end: '02:50 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading:
        'Transforming Transportation: Electrifying India’s Mobility',
      ytLink: 'https://youtu.be/9FV0OPuOMSM?feature=shared',
      speakers: [
        {
          name: 'Aparna Mangla',
          designation:
            'Investment Director, Private Equity Funds and Co-Investments, British International Investment (BII)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/aparnamangla-c2uAarqcXhjc.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/aparna-mangla',
        },
        {
          name: 'Kartik Gopal',
          designation:
            'Global EV Industry Specialist, International Finance Corporation (IFC)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-22at35158PM-30WupjasOyqt.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/kartik-gopal',
        },

        {
          name: 'Nakul Zaveri',
          designation:
            'Partner & Co-Head Climate Investment Strategy, Leapfrog Investments',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/NakulZaveri-qW3n1UZbEjZk.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/nakul-zaveri',
        },
        {
          name: 'Shekhar Mishra,',
          designation: 'Head of Strategy and Finance, Hero MotoCorp',
        },

        {
          name: 'Samir Yajnik',
          designation: 'Executive Director, Electra EV ',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/samir-yajnik',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/samiryajnik-n3qoflRqZmA4.jpg',
        },
        {
          name: 'Raj Pai',
          designation: 'Founding Partner, GEF Capital Partners (Moderator)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/rajpai-VbXSm3orlA6K.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/raj-pai',
        },
      ],
    },
    {
      id: 'Day1_8',
      timing: {
        start: '02:50 PM',
        end: '03:00 PM',
      },
      normalHeading: 'Start-up Showcase Session',

      ytLink: 'https://youtu.be/Df_Ced-8b7A?feature=shared',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
    },
    {
      id: 'Day2_10',
      timing: {
        start: '03:00 PM',
        end: '03:40 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading: 'Green Credit: Filling the transition funding gap',
      ytLink: 'https://youtu.be/18iHf4PzNTM?feature=shared',
      speakers: [
        {
          name: 'Karthik B. Athreya',
          designation:
            'Director & Head - Strategy - Alternative Credit, Sundaram Alternates',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/IMG0058-OaJwLBvmnLgl.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/karthik-athreya',
        },
        {
          name: 'Shaurya Arora',
          designation: 'Chief Investment Officer & Partner, UTI Alternatives',
        },

        {
          name: 'Laurent Gonnet',
          designation: 'Lead Financial Sector Specialist, World Bank',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/laurent-gonnet',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/laurent-hjB8vG4plmbY.webp',
        },
        {
          name: 'Nilesh Shrivastava',
          designation:
            'Partner - Strategic Opportunities Fund, National Investment and Infrastructure Fund (NIIF)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-22at30153PM-A8st1F5QpYyF.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/nilesh-shrivastava',
        },
        {
          name: 'Upasana Rao',
          designation: 'Partner, Trilegal (Moderator)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/UpasanaRaonew-MqnoyVysIGSn.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/upasana-rao',
        },
      ],
    },
    {
      id: 'Day2_11',
      timing: {
        start: '03:40 PM',
        end: '04:00 PM',
      },
      accentTag: 'Break',
      normalHeading: 'Networking High Tea',
    },
    {
      id: 'Day2_13',
      timing: {
        start: '04:00 PM',
        end: '04:40 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading:
        'Equity Financing for India’s energy transition ambitions: opportunities, challenges and way forward',
      ytLink: 'https://youtu.be/yMtLk-twVYw?feature=shared',
      speakers: [
        {
          name: 'Ami Momaya',
          designation: 'Director, KKR',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-26at43734PM-vxmPzQfmY2dg.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/ami-momaya',
        },
        {
          name: 'Anoop Poddar',
          designation: 'Senior Managing Director, Eversource Capital',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/anoop-poddar',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-29at65635PM-qW3d1ULIthu3.png',
        },
        {
          name: 'Helly Ajmera',
          designation:
            'Director and Head of India Investments, British Columbia Investment Management Corporation (BCI)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/hellyajmera-UpLJWy1KSSJz.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/helly-ajmera',
        },
        {
          name: 'Bharat Anand',
          designation: 'Partner, Khaitan & Co.',
        },

        {
          name: 'Srishti Ahuja',
          designation:
            'Infrastructure Strategy and Transactions Partner, EY India (Moerator)',
          //   profileImg:
          link: 'https://www.ivca.in/greenReturns-2024/speakers/srishti-ahuja',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/DSC9246-eg6MlkFwgLCh.jpg',
        },
      ],
    },
    {
      id: 'Day2_14',
      timing: {
        start: '04:40 PM',
        end: '05:20 PM',
      },
      accentTag: 'Discussion Session',
      normalHeading:
        'Innovative Financing Mechanisms: Blended Finance and more.',
      ytLink: 'https://youtu.be/IBW4fmpfLuw?feature=shared',
      speakers: [
        {
          name: 'Laurent Gonnet',
          designation: 'Lead Financial Sector Specialist, World Bank',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/laurent-gonnet',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/laurent-hjB8vG4plmbY.webp',
        },
        {
          name: 'Samonnoi Banerjee',
          designation: 'Allied Climate Partners',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/samonnoi-banerjee',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-25at33614PM-aytKN6uNvtLv.png',
        },
        {
          name: 'Vandana Bahri',
          designation:
            "Head, Skills and Livelihood, Children's Investment Fund Foundation (CIFF)",

          link: 'https://www.ivca.in/greenReturns-2024/speakers/vandana-bahri',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-28at61635PM-iPDUf0uQR17x.jpeg',
        },
        {
          name: 'Aparna Dua',
          designation: 'Director, The Blended Finance Company (TBFC)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-29at65959PM-LkpyHy8PzKCr.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/aparna-dua',
        },
        {
          name: 'Himanshu Sikka',
          designation:
            'Chief Strategy & Diversification Officer and Lead – Health, Nutrition & WASH, IPE Global ',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/himanshu-sikka',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/himanshusikka-KQ52QqCWvZM6.jpg',
        },
        {
          name: 'Kartikeya Desai',
          designation: 'CEO, Desai & Associates (Moderator)',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/kartikeya-desai',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/kdofficialpic-mox83bmYW2S6.jpg',
        },
      ],
    },
    {
      id: 'Day2_15',
      timing: {
        start: '05:20 PM',
        end: '05:30 PM',
      },
      normalHeading: 'Closing Remarks',
      speakers: [
        {
          name: 'Shri Jayant Sinha',
          designation:
            'Former Union Minister of State for Finance and Civil Aviation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-29at174249-HXVetJKDJbnv.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/jayant-sinha',
        },
      ],
    },
    {
      id: 'Day2_16',
      timing: {
        start: '05:30 PM',
        end: '09:00 PM',
      },
      normalHeading: 'Closing Gala Dinner and Networking Cocktails',
    },
  ],
];

// eslint-disable-next-line arrow-body-style
const AgendaDay2 = () => {
  return (
    <Container maxW="container.lg">
      <Box padding={{ xs: '50px 0px', md: '100px 50px 56px' }} mt="10px">
        <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          December 3rd 2024
        </Text>
        {/* <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="black"
          textAlign="left"
          mb="2rem"
        >
          To be announced...
        </Text> */}

        <AgendaWrapper
          itemsContainerProps={{
            px: '0',
          }}
          accordionProps={{
            defaultIndex: [2],
          }}
        >
          {agendaDay2[0].map((item) => (
            <EventCard
              key={item.id}
              event={item}
              labelTextColor="#197542"
              customSpeakerStyles
            />
          ))}
        </AgendaWrapper>
      </Box>
    </Container>
  );
};

export default AgendaDay2;
